import { render, staticRenderFns } from "./LinkPratica.vue?vue&type=template&id=030dc25a&"
import script from "./LinkPratica.vue?vue&type=script&lang=js&"
export * from "./LinkPratica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('030dc25a')) {
      api.createRecord('030dc25a', component.options)
    } else {
      api.reload('030dc25a', component.options)
    }
    module.hot.accept("./LinkPratica.vue?vue&type=template&id=030dc25a&", function () {
      api.rerender('030dc25a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/LinkPratica.vue"
export default component.exports